import type { FC } from "react";

export type Props = {
  firstStepText: string;
  secondStepText: string;
  thirdStepText: string;
  playNowText: string;
  playNowLink: string;
  analytics: { playNow: () => void };
};
/**
 * @deprecated
 */
export const PromoPageSteps: FC<Props> = (data) => {
  const redirectToRoom = (): void => {
    if (data.playNowLink) {
      window.location.href = data.playNowLink;
    }
  };
  const onPlayNow = (): void => {
    data.analytics.playNow();
    redirectToRoom();
  };
  return (
    <div className="flex-col flex justify-center lg:flex lg:flex-row lg:justify-between gap-5 items-center max-w-[1240px] mx-auto p-8">
      <div className="lg:flex lg:flex-row lg:justify-between gap-y-6 lg:gap-4 items-center flex-col flex">
        <div className="flex flex-col lg:flex lg:flex-row  items-center gap-2 lg:gap-4 xl:w-[294px] md:w-[240px] ">
          <div className="w-10 h-10 lg:w-11 lg:h-11 flex-shrink-0 rounded-full border-2 border-white flex justify-center items-center ">
            1
          </div>
          <span className="leading-7 text-[20px] font-bold text-center">
            {data.firstStepText}
          </span>
        </div>
        <div className="flex flex-col lg:flex lg:flex-row items-center gap-2 lg:gap-4 xl:w-[294px]   md:w-[240px]">
          <div className="w-10 h-10 lg:w-11 lg:h-11 flex-shrink-0 rounded-full border-2 border-white flex justify-center items-center  ">
            2
          </div>
          <span className="leading-7 text-[20px] font-bold text-center">
            {data.secondStepText}
          </span>
        </div>
        <div className="flex flex-col lg:flex lg:flex-row  items-center gap-2 lg:gap-4 xl:w-[294px] md:w-[240px] ">
          <div className="w-10 h-10 lg:w-11 lg:h-11  flex-shrink-0 rounded-full border-2 border-white flex justify-center items-center   ">
            3
          </div>
          <span className="leading-7 text-[20px] font-bold text-center">
            {data.thirdStepText}
          </span>
        </div>
      </div>
      <button
        onClick={onPlayNow}
        className=" mt-6 lg:m-0 bg-white  text-black  text-center rounded-[4px] px-6 py-3 text-[16px] leading-6 lg:px-12 lg:py-[18px] lg:text-[20px] lg:leading-7 font-bold "
      >
        {data.playNowText}
      </button>
    </div>
  );
};
